<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <v-layout wrap mt-3>
      <v-flex xs6 text-xs-center v-for="i in 2" :key="alts[i]">
        <button class="hvr-scale" :class="vistos[i-1]?'bot-check-vis-cen':''" @click="currentText = i, $set(vistos,i-1,true)">
          <img :src="require('../../assets/Modulo 1/diapositiva-4-'+ i +'.png')" :alt="alts[i-1]">
        </button>
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <v-flex xs12 lg8 v-if="text != ''" class="animated fadeInUp faster">
        <transition name="custom" enter-active-class="animated fadeInUp faster" leave-active-class="animated fadeOutDown faster" mode="out-in">
          <p class="texto1 mt-4" :key="text">
            <span v-html="text"></span>
          </p>
        </transition>
      </v-flex>
    </v-layout>
    
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 1/AUDIO 05'
    ]"></audio-player> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogos: [
        "También hablamos de la importancia de las reservas y los recursos, existen dos razones que justifican dicha importancia, para Ecopetrol: <span class='instruccion'>haz clic en los iconos</span>"
      ],
      alts: [
        "",
        ""
      ],
      vistos: [false,false],
      currentText: 0
    }
  },
  computed: {
    text: function() {
      switch (this.currentText){
        case 1: return "Las reservas y los recursos constituyen la base física de la actividad en la exploración y producción de hidrocarburos.";
        case 2: return "Las reservas son los principales activos de la generación de ingresos de ECOPETROL S.A., su correcta estimación determina el éxito de la empresa.";
        default: return ""
      }
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  },
  watch: {
    vistos: function(newValue){
      var todosVistos = newValue.every(el => {return el})
      if(todosVistos) {
        this.$store.commit('nextShow', true)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
